import { useEffect, useState } from "react";
import Table from "../../../../components/common/table/Table";
import Button from "../../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { memberActions } from "../../../../_store/members.slice";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import CustomLoader from "../../../../components/common/ui/Loader";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import SelectInput from "../../../../components/common/ui/Inputs/SelectInput";
import { history } from "../../../../_helpers";
import { showToastNotification } from "../../../../components/common/ui/NotificationModal/ToastNotication";
import ToggleSwitch from "../../../../components/common/ui/Inputs/ToggleSwitch";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import { masterActions } from "../../../../_store/master.slice";
import formatPhoneNumber from "../../../../_helpers/formatPhoneNumber";
import warningIcon from "../../../../assets/constant-contact-warning.png";
import EmailUnsubscribe from "../../../../assets/email-unsubscribe.png";
import { FaFileExcel } from "react-icons/fa";
import { exportExcel } from "../../../../utils/exportExcel";

function Member() {
  const dispatch = useDispatch();
  const { membersList, loading } = useSelector((x) => x?.members);
  // const { exportMembersList } = useSelector((x) => x?.exportMembersList);

  const { rolesList } = useSelector((x) => x?.master);
  const { ActiveStatus } = useSelector((x) => x?.dropDown);
  const userList = membersList?.data?.users;
  const totalCount = membersList?.data?.totalItems || 0;

  // const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState({
    memberId: "",
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    phoneNumber: "",
    status: true,
  });
  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`,
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);

  const trimmedEntries = Object.entries(filters)
    .filter(([_, v]) => v !== "" && v !== null && v !== undefined)
    .map(([k, v]) => [k, typeof v === "string" ? v.trim() : v]);

  useEffect(() => {
    dispatch(masterActions?.getRolesList());
  }, []);

  useEffect(() => {
    const params = apiParams;
    dispatch(memberActions?.getMembers(params));
  }, []);

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "10",
      ...Object.fromEntries(trimmedEntries),
    }).toString();

    setApiParams(`?${query}`);
  }, [filters]);

  const columns = [
    {
      // width: "120px",
      name: "Member ID",
      key: "memberId",
      selector: (row) => row.memberId,
      sortable: true,
    },
    {
      // width: "150px",
      name: "First Name",
      key: "firstName",
      selector: (row) => row.firstName,
      sortable: true,
    },
    {
      // width: "150px",
      name: "Last Name",
      key: "lastName",
      selector: (row) => row.lastName,
      sortable: true,
    },
    {
      name: "Email",
      key: "email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Alternative Email",
      key: "email",
      selector: (row) => row?.altEmail,
      sortable: true,
    },

    {
      name: "Phone No",
      key: "phoneNumber",
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: "Role",
      key: "role",
      selector: (row) => row.role,
      cell: (row) => (
        <div className="">
          {row.role === 3
            ? "Super Admin"
            : row?.role === 2
              ? "Committee Chair"
              : "Committee Member"}
        </div>
      ),
      sortable: true,
    },

    {
      // width: "80px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleEditMember(row);
            }}
          />

          <ToggleSwitch
            show={(!row?.otpValidationTime && row?.ccIsVerified)}
            name={`Status${row.InmateID}`}
            id={`Status${row.InmateID}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleMemberStatus(e, row)}
          />

          {row?.ccIsEmailSubscription === true &&
            row?.ccIsVerified === false &&
            row?.role !== 3 && (
              <div className="d-flex gap-2">
                <img
                  src={warningIcon}
                  title="Member may not be mapped to the committee in CC. Reconnect CC and update to reflect the changes"
                  alt="warning-icon"
                  aria-hidden="true"
                  className="sbpc-icon-size ignore-toggle"
                  onClick={(e) => {
                    e.stopPropagation();
                    e?.preventDefault();
                  }}
                />
              </div>
            )}
          {row?.ccIsEmailSubscription === false && row?.role !== 3 && (
            <div className="d-flex gap-2">
              <img
                src={EmailUnsubscribe}
                title="Un-Subscribed Email in CC"
                alt="warning-icon"
                aria-hidden="true"
                height={"20px"}
                width={"20px"}
                onClick={(e) => {
                  e.stopPropagation();
                  e?.preventDefault();
                }}
              />
            </div>
          )}
        </div>
      ),
      sortable: false,
    },
  ];

  const handleMemberStatus = (e, row) => {
    dispatch(
      memberActions.changeUserStatusMaster({
        id: row?._id,
        status: e.target.checked,
      }),
    )
      .then((result) => {
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          dispatch(memberActions?.getMembers(apiParams));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to delete members", "error");
      });
  };
  const handleEditMember = (row) => {
    history?.navigate("/Admin/Member/createOrEdit", {
      state: { memberID: row?._id },
    });
  };

  const handleSearchChange = (e, select) => {
    if (select) {
      setFilters((prev) => ({
        ...prev,
        [select]: e?.value === undefined ? "" : e?.value,
      }));
      return;
    }

    const { name, value, type } = e.target;
    if (value.startsWith(" ")) return;
    if (name === "phoneNumber") {
      const target = e?.target || {};
      const selectionStart = target.selectionStart || 0;
      const digitsOnly = value.replace(/\D/g, "");
      const formattedNumber = formatPhoneNumber(digitsOnly);

      requestAnimationFrame(() => {
        const inputElem = document.querySelector(`input[name="phoneNumber"]`);
        if (inputElem) {
          const newCursorPos = calculateNewCursorPosition(
            selectionStart,
            value,
            formattedNumber,
          );
          inputElem.setSelectionRange(newCursorPos, newCursorPos);
        }
      });

      setFilters((prev) => ({
        ...prev,
        phoneNumber: formattedNumber,
      }));
      return;
    }
    setFilters((prev) => ({
      ...prev,
      [name]: type === "radio" ? (value === "true" ? true : false) : value,
    }));
  };

  const calculateNewCursorPosition = (oldPos, oldValue, newValue) => {
    let rawIndex = 0;
    let newIndex = 0;

    while (rawIndex < oldPos && newIndex < newValue.length) {
      if (/\d/.test(oldValue[rawIndex])) {
        while (newIndex < newValue.length && !/\d/.test(newValue[newIndex])) {
          newIndex++;
        }
        newIndex++;
      }
      rawIndex++;
    }
    return newIndex;
  };

  // const handleRowPerPage = (page) => {
  //   const updatedParams = apiParams.replace(/&limit=\d+/, `&limit=${page}`);
  //   setApiParams(updatedParams);
  //   dispatch(memberActions?.getMembers(updatedParams));
  //   setRowCountPerPage(page);
  //   setPageNo(1);
  // };


  const handleRowPerPage = (pageSize) => {
    const query = new URLSearchParams({
      page: "1",
      limit: pageSize,
      ...Object.fromEntries(
        trimmedEntries
      ),
    }).toString();

    const params = `?${query}`;

    setApiParams(params);
    setRowCountPerPage(pageSize);
    setPageNo(1);

    dispatch(memberActions?.getMembers(params));
  };

  const handlePageChange = (page) => {
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    setApiParams(updatedParams);
    dispatch(memberActions?.getMembers(updatedParams));
    setPageNo(page);
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(memberActions?.getMembers(apiParams));
  };

  const handleFormReset = (e) => {
    e?.preventDefault();
    setFilters({
      firstName: "",
      lastName: "",
      email: "",
      role: "",
      status: true,
    });
    const params = `?page=${1}&limit=${10}&status=${true}`;
    setApiParams(params);
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(memberActions?.getMembers(params));
  };



  const onExport = () => {
    const query = new URLSearchParams({
      page: "1",
      limit: totalCount,
      ...Object.fromEntries(trimmedEntries),
    }).toString();

    dispatch(memberActions.getExportMembers(`?${query}`))
      .unwrap()
      .then((result) => {
        debugger;
        const formattedData = result?.data?.users?.map((item) => ({
          "Member ID": item.memberId,
          "First Name": item.firstName,
          "Last Name": item.lastName,
          Email: item.email, // optional
          "Alternative Email": item.altEmail,
          "Phone No": item.phoneNumber, // optional
          Role:
            item.role === 3
              ? "Super Admin"
              : item?.role === 2
                ? "Committee Chair"
                : "Committee Member",
        }));
        exportExcel(formattedData, "Member-Report.xlsx", "Member_List");
      })
      .catch((err) => {
        console.error("Export failed:", err);
      });

    // const { fromDate, toDate } = filters;
    // switch (type) {
    //   case "SuperAdminLoginStatus":
    //     dispatch(
    //       superAdminDashboardActions.exportSuperAdminLoginStatus({
    //         startDate: fromDate,
    //         endDate: toDate,
    //       })
    //     )
    //       .unwrap()
    //       .then((result) => {
    //         const formattedData = result.map((item) => ({
    //           Month: item.month,
    //           Year: item.year,
    //           Committee: item.committeeName,
    //           "Logged In User List": item.logedInUsersList.join(", "), // optional
    //           "Logged In Users Count": item.logedInUsersCount,
    //           "Not Logged In User List": item.notLogedInUsersList.join(", "), // optional
    //           "Not Logged In Users Count": item.notLogedInUsersCount,
    //         }));
    //         exportExcel(
    //           formattedData,
    //           "User-Login-report.xlsx",
    //           "Login_Status"
    //         );
    //       })
    //       .catch((err) => {
    //         console.error("Export failed:", err);
    //       });
    //     break;
    //   case "CommitteeAdminLoginStatus":
    //     dispatch(
    //       committeeAdminDashboardActions.exportCommitteeLoginStatus({
    //         committee: selectedCommittee,
    //         startDate: fromDate,
    //         endDate: toDate,
    //       })
    //     )
    //       .unwrap()
    //       .then((result) => {
    //         const formattedData = result.map((item) => ({
    //           Month: item.month,
    //           Year: item.year,
    //           Committee: item.committeeName,
    //           "Logged In User List": item.logedInUsersList.join(", "), // optional
    //           "Logged In Users Count": item.logedInUsersCount,
    //           "Not Logged In User List": item.notLogedInUsersList.join(", "), // optional
    //           "Not Logged In Users Count": item.notLogedInUsersCount,
    //         }));
    //         exportExcel(
    //           formattedData,
    //           "User-Login-report.xlsx",
    //           "Login_Status"
    //         );
    //       })
    //       .catch((err) => {
    //         console.error("Export failed:", err);
    //       });
    //     break;
    //   case "CommitteeAdminEvents":
    //     dispatch(
    //       committeeAdminDashboardActions.exportCommitteeAdminEventData({
    //         committee: selectedCommittee,
    //         startDate: fromDate,
    //         endDate: toDate,
    //       })
    //     )
    //       .unwrap()
    //       .then((result) => {
    //         const formattedData = result.map((item) => ({
    //           Month: item.month,
    //           Year: item.year,
    //           "Total Events": item.eventCount,
    //         }));

    //         exportExcel(formattedData, "committee-Event-report.xlsx", "Events");
    //       })
    //       .catch((err) => {
    //         console.error("Export failed:", err);
    //       });
    //     break;
    //   case "SuperAdminEvents":
    //     dispatch(
    //       superAdminDashboardActions.exportSuperAdminEventData({
    //         startDate: fromDate,
    //         endDate: toDate,
    //       })
    //     )
    //       .unwrap()
    //       .then((result) => {
    //         const formattedData = result.map((item) => ({
    //           Month: item.month,
    //           Year: item.year,
    //           "Committee Name": item?.committeeName,
    //           "Total Events": item?.eventCount,
    //         }));

    //         exportExcel(
    //           formattedData,
    //           "SuperAdmin-Event-report.xlsx",
    //           "Events"
    //         );
    //       })
    //       .catch((err) => {
    //         console.error("Export failed:", err);
    //       });
    //     break;
    //   case "SuperAdminMembers":
    //     dispatch(
    //       superAdminDashboardActions.exportSuperAdminMembersCountData({
    //         startDate: fromDate,
    //         endDate: toDate,
    //       })
    //     )
    //       .unwrap()
    //       .then((result) => {
    //         const formattedData = result.map((item) => ({
    //           Month: item.month,
    //           Year: item.year,
    //           "Committee Name": item?.committeeName,
    //           "Members Count": item?.userCount,
    //         }));

    //         exportExcel(
    //           formattedData,
    //           "SuperAdmin-Members-report.xlsx",
    //           "Members"
    //         );
    //       })
    //       .catch((err) => {
    //         console.error("Export failed:", err);
    //       });
    //     break;
    //   default:
    //     console.error("Export failed:");
    // }
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <h1 className="header-color">Members</h1>
        <Button
          status="secondary"
          label="Create Member"
          onClick={() => {
            history?.navigate("/Admin/Member/createOrEdit", {
              state: { memberID: 0 },
            });
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          Search Member
        </h1>
        <form
          className="p-3 row"
          onSubmit={(e) => {
            handleSearchSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
        >
          <div className="col-md-3">
            <TextInput
              label="Member ID"
              placeholder="Member ID"
              name="memberId"
              id="memberId"
              handleChange={handleSearchChange}
              value={filters?.memberId}
            />
          </div>
          <div className="col-md-3">
            <TextInput
              label="First Name"
              placeholder="First name"
              name="firstName"
              handleChange={handleSearchChange}
              value={filters?.firstName}
            />
          </div>
          <div className="col-md-3">
            <TextInput
              label="Last Name"
              placeholder="Last name"
              name="lastName"
              handleChange={handleSearchChange}
              value={filters?.lastName}
            />
          </div>
          <div className="col-md-3">
            <TextInput
              label="Email"
              placeholder="Email"
              name="email"
              handleChange={handleSearchChange}
              value={filters?.email}
            />
          </div>
          <div className="col-md-3">
            <TextInput
              label="Phone Number"
              placeholder="Phone number"
              name="phoneNumber"
              id="phoneNumber"
              handleChange={(e) => handleSearchChange(e)}
              value={filters?.phoneNumber}
            />
          </div>
          <div className="col-md-3">
            <SelectInput
              options={rolesList?.data}
              label="Role"
              name="role"
              handleChange={(e) => handleSearchChange(e, "role")}
              value={filters?.role}
            />
          </div>

          <div className="col-md-3">
            <RadioInput
              name="status"
              id="status"
              label="Status"
              options={ActiveStatus}
              handleChange={(e) => handleSearchChange(e)}
              selectedValue={filters?.status}
              value={filters?.status}
            />
          </div>

          <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
            <Button status="secondary" label="Search" type="submit" />
            <Button status="reset" label="Reset" type="reset" />
          </div>
        </form>
      </div>

      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <div className="d-flex justify-content-between align-items-center p-3">
          <h1 className="m-0 search-header-color">Member List</h1>
          <button
            className="btn btn-success btn-sm d-flex align-items-center gap-1"
            onClick={() => onExport()}
          >
            <FaFileExcel size={14} />
            <span>Export to Excel</span>
          </button>
        </div>
        <Table
          columns={columns}
          data={userList}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={totalCount || 0}
          currentPage={pageNo}
          paginationPerPage={rowCountPerPage}
        />
      </div>
    </>
  );
}

export default Member;
